import { handleize } from "@/helpers/userHelpers";
import React from "react";

import styles from "../Footer.module.scss";

export default function FooterLinks({footerData,showTitle = true,viewType = "mobile",}) {
  return (
    <div className="grid-sm-3 grid-md-3 grid-xs-12 p-none">
      <div className="wrapper">
        {showTitle && (
          <div className={styles.title_wrapper}>
            <p className={`normal-md x-small-sm small-xs bold ${styles.desktop}`}>
              {footerData.linkItem.title}
            </p>
          </div>
        )}
        <ul>
          {footerData.linkItem.links.map((value, index) => {
            return (
              <li className={styles.item} key={index}>
                <a id={`${handleize(value.link_title)}-${index}-${viewType}`}className="x-small-md xx-small-sm x-small-xs ga_footer_link_text"href={value.link_href}
                  tabIndex={0}>
                  {value.link_title}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}